<template>
  <div class="fixed-talk-head">
    <div class="inner">
      <div class="main">
        <h2 class="title" :title="info.article_title">{{info.article_title | formatContent}}</h2>
        <div class="operation">
          <div :class="['share-btn', 'collection-btn', {'favorite': isFavorite}]" @click="toggleFavorite">
            <i class="iconfont">&#xe60b;</i> 
            {{isMobile ? '' : '收藏'}}
          </div>
          <div class="share-btn comment-btn" @click="$emit('goComment')">
            <i class="iconfont">&#xe643;</i> {{isMobile ? '' : '评论'}}
          </div>
          <div class="share-btn weixin" @mouseenter="touchWxStatus = true" @mouseleave="touchWxStatus = false" v-if="!isMobile">
            <i class="iconfont">&#xe63c;</i> 微信
            <transition name="slide-in-bottom">
              <div class="popup-box bottom" v-if="touchWxStatus">
                <div class="popup-content">
                  <QrCode :size="87" :val="articleWxShareUrl" />
                </div>
              </div>
            </transition>
          </div>
          <div class="share-btn weibo" @click="$emit('weiboShare')">
            <i class="iconfont">&#xe63b;</i> {{isMobile ? '': '微博'}}
          </div>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import QrCode from '../../components/qrcode'
export default {
  name: 'fixed-talk-head',
  components: {
    QrCode
  },
  props: {
    info: VueTypes.object.def({}),
    isMobile: VueTypes.bool.def(false),
    articleWxShareUrl: VueTypes.string.def(''),
    isFavorite: VueTypes.oneOfType([Number, Boolean])
  },
  data () {
    return {
      touchWxStatus: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    toggleFavorite () {
      this.$emit('toggleFavorite', 'fixed-talk-head')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.fixed-talk-head {
  position: fixed; z-index: 100; top: 69px; left: 0;
  width: 100%; height: 53px;
  background: #fff;
  box-shadow: 0px 3px 4px 0px rgba(229, 229, 229, 0.6);

  & .inner {
    width: 1080px; height: 53px;
    margin: 0 auto;
  }

  & .main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 736px; height: 100%;
  }

  & .title {
    flex: 1;
    @extend %row;
    @include font(20, 600);
    color: $lightBlack;
  }

  & .operation {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    @include font(14, 500);
    user-select: none;
  }

  & .share-label {
    padding-left: 18px;
    color: #828A92;
  }

  & .share-btn {
    position: relative;
    margin-left: 20px;
    cursor: pointer;
  }

  // 评论
  & .comment-btn {
    color: #828A92;
    & .iconfont {
      position: relative; top: 1px;
    }

    &:hover {
      color: $grayHover;
      & .iconfont {
        color: $blue;;
      }
    }
  }

  & .collection-btn {
    color: #828A92;
    &:hover {
      color: $grayHover;
      & .iconfont {
        color: #F3B42C;
      }
    }
  }

  & .collection-btn.favorite {
    & .iconfont {
      color: #F3B42C;
    }
  }

  & .weibo {
    color: #828A92;

    &:hover {
      color: $grayHover;
      & .iconfont {
        color: #EA5B48;;
      }
    }
  }

  & .weixin {
    position: relative;
    color: #828A92;
    cursor: pointer;

    &:hover {
      color: $grayHover;
      & .iconfont {
        color: #47C862;
      }
    }

    & .popup-box {
      position: absolute; top: 30px; z-index: 300;
      
      & .popup-content {
        box-sizing: border-box;
        position: relative;
        padding: 10px;
        background: #FFF;
        border: 1px solid $borderGray; border-radius: 3px;
        box-shadow: $shadowGray;
        cursor: default;

        &:before,
        &:after {
          content: ' ';
          display: block;
          position: absolute;
          width: 0; height: 0;
        }

      }

      &.bottom {
        left: -28px;
        // padding-bottom: 60px;

        & .popup-content {
          &:before,
          &:after {
            left: 50%;
            transform: translateX(-50%);
          }

          &:before {
            top: -9px;
            border-bottom: 8px solid $borderGray;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
          }

          &:after {
            top: -8px;
            border-bottom: 8px solid #FFF;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
          }
        }
        
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .fixed-talk-head {
    top: 45px;
    height: 40px;

    & .inner {
      width: 100%; height: 40px;
      margin: 0 auto;
    }

    & .main {
      box-sizing: border-box;
      width: auto;
      padding: 0 20px;
    }

    & .title {
      @include font(16, 600);
    }

    & .collection-btn {
      &:hover {
        color: $grayHover;
        & .iconfont {
          color: $grayHover;
        }
      }
    }

    & .collection-btn.favorite {
      & .iconfont {
        color: #F3B42C;
      }
    }
  }
}

.slide-in-bottom-enter-active,
.slide-in-bottom-leave-active {
  transition: all 0.3s ease;
}
.slide-in-bottom-enter,
.slide-in-bottom-leave-to {
  transform: translateY(-5px);
  opacity: 0;
}
</style>